export function generateDefaultSearchData() {
    return {
        jobs: [],
        pageCursors: new Map(),
        filterOptions: {
            datePosted: [],
            remoteWorkTypes: [],
            jobCategories: [],
        },
    };
}
